export default __webpack_public_path__ + "static/media/template_ln.85976979.svg";